module.exports = __webpack_public_path__ + "static/media/image-33.1396aac5.png";